module.exports = {
	EnterFrameEvent: require("./EnterFrameEvent").default,
	Event: require("./Event").default,
	EventDispatcher: require("./EventDispatcher").default,
	KeyboardEvent: require("./KeyboardEvent").default,
	ResizeEvent: require("./ResizeEvent").default,
	Touch: require("./Touch").default,
	TouchData: require("./TouchData").default,
	TouchEvent: require("./TouchEvent").default,
	TouchMarker: require("./TouchMarker").default,
	TouchPhase: require("./TouchPhase").default,
	TouchProcessor: require("./TouchProcessor").default,
}


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/index.js
// module id = 303
// module chunks = 0